

export const logIn = (api, data) => {
    return api.post("/api/v1/Authentication/logIn", data)
}

export const ResetPassword = (api, email) => {
    return api.get(`/api/v1/Authentication/ResetPassword?email=${email}`)
}

export const UsersForChangePassword = (api, link) => {
    var changePasswordVM = {
        Link: link,
        CustId: '',
        Password: '',
        MarketingAgree: false,
        MarketingAgreeEmail: false,
        MarketingAgreePhone: false,
        MarketingAgreeSms: false
    }
    return api.post(`/api/v1/Authentication/UsersForChangePassword`, changePasswordVM)
}

export const ChangePassword = (api, link, custId, password, marketingAgree, marketingAgreeEmail, marketingAgreePhone, marketingAgreeSms) => {
    var changePasswordVM = {
        Link: link,
        CustId: custId,
        Password: password,
        MarketingAgree: marketingAgree,
        MarketingAgreeEmail: marketingAgreeEmail,
        MarketingAgreePhone: marketingAgreePhone,
        MarketingAgreeSms: marketingAgreeSms
    }
    return api.post(`/api/v1/Authentication/ChangePassword`, changePasswordVM)
}


